import { render, staticRenderFns } from "./white-list.vue?vue&type=template&id=6e56ca7a&scoped=true&"
import script from "./white-list.vue?vue&type=script&lang=ts&"
export * from "./white-list.vue?vue&type=script&lang=ts&"
import style0 from "./white-list.vue?vue&type=style&index=0&id=6e56ca7a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e56ca7a",
  null
  
)

export default component.exports